import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Tabs, Button } from '@components';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { NovoRequerimento } from './components/NovoRequerimento';
import { EmAndamento } from './components/EmAndamento';
import { Deferidos } from './components/Deferidos';
import { Indeferidos } from './components/Indeferidos';
import { obterFormulariosRequest } from '../../store/modules/requerimento/actions';
import { Pendentes } from './components/Pendentes';

function chooseActiveTab(pathname = '') {
  if (pathname.includes('/novo')) {
    return 'Novo requerimento';
  }
  if (pathname.includes('/andamento')) {
    return 'Em andamento';
  }
  if (pathname.includes('/deferidos')) {
    return 'Deferidos';
  }
  if (pathname.includes('/indeferidos')) {
    return 'Indeferidos';
  }
  if (pathname.includes('/pendente')) {
    return 'Pendente Correção';
  }

  return 'Novo requerimento';
}

const routeByActiveTab = {
  'Novo requerimento': 'novo',
  'Em andamento': 'andamento',
  Deferidos: 'deferidos',
  Indeferidos: 'indeferidos',
  'Pendente Correção': 'pendente',
};

export const RequerimentosPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const activeTab = chooseActiveTab(location.pathname);

  useEffect(() => {
    const basePath = `/requerimentos/${routeByActiveTab[activeTab]}`;
    const isAlreadyInTab = location.pathname.startsWith(basePath);

    if (!isAlreadyInTab) {
      navigate(`${basePath}/*`);
    }
    // useNavigate changes when the current location changes. It depends on it for relative navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const allFormsRequestDone = useSelector(
    (state) => state.requerimento.allFormsRequestDone
  );

  useEffect(() => {
    if (!allFormsRequestDone) {
      dispatch(obterFormulariosRequest());
    }
  }, [allFormsRequestDone, dispatch]);

  return (
    <>
      <Helmet>
        <title>Forluz - Requerimentos</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-2">Requerimentos</h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-2)}
        >
          Voltar
        </Button>
      </div>
      <Tabs active={`${activeTab}`}>
        <div
          label="Novo requerimento"
          onClick={() => {
            navigate('/requerimentos/novo/*');
          }}
          aria-hidden
        >
          <Routes>
            <Route path="/novo/*" element={<NovoRequerimento />} />
          </Routes>
        </div>
        <div
          label="Em andamento"
          onClick={() => {
            navigate('/requerimentos/andamento/*');
          }}
          aria-hidden
        >
          <Routes>
            <Route path="/andamento/*" element={<EmAndamento />} />
          </Routes>
        </div>
        <div
          label="Pendente Correção"
          onClick={() => {
            navigate('/requerimentos/pendente/*');
          }}
          aria-hidden
        >
          <Routes>
            <Route path="/pendente/*" element={<Pendentes />} />
          </Routes>
        </div>
        <div
          label="Deferidos"
          onClick={() => {
            navigate('/requerimentos/deferidos/*');
          }}
          aria-hidden
        >
          <Routes>
            <Route path="/deferidos/*" element={<Deferidos />} />
          </Routes>
        </div>
        <div
          label="Indeferidos"
          onClick={() => {
            navigate('/requerimentos/indeferidos/*');
          }}
          aria-hidden
        >
          <Routes>
            <Route path="/indeferidos/*" element={<Indeferidos />} />
          </Routes>
        </div>
      </Tabs>
    </>
  );
};
